export default "__VITE_ASSET__Dzx94sy3__"